// utils/commonServiceClassificationRulesUtils.js

const CONSULTATIONS_CATEGORY_ID = Number(
  process.env.REACT_APP_CONSULTATIONS_CATEGORY_ID,
);

const NGK_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_NGK_SERVICE_TYPE_EXT_ID,
);

const SGK_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_SGK_SERVICE_TYPE_EXT_ID,
);

const GSK_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_GSK_SERVICE_TYPE_EXT_ID,
);

const SGKN_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_SGKN_SERVICE_TYPE_EXT_ID,
);

const VGSK_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_VGSK_SERVICE_TYPE_EXT_ID,
);

const NVGK_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_NVGK_SERVICE_TYPE_EXT_ID,
);

const EXPRESS_CARE_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_EXPRESS_CARE_SERVICE_TYPE_EXT_ID,
);

const ABUS_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_ABUS_SERVICE_TYPE_EXT_ID,
);

const KT_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_KT_SERVICE_TYPE_EXT_ID,
);

const MRT_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_MRT_SERVICE_TYPE_EXT_ID,
);

const M3DT_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_M3DT_SERVICE_TYPE_EXT_ID,
);

const XRAY_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_XRAY_SERVICE_TYPE_EXT_ID,
);

const ULTRASOUND_SERVICE_TYPE_EXT_ID = Number(
  process.env.REACT_APP_ULTRASOUND_SERVICE_TYPE_EXT_ID,
);

const SG_SPECIALTY_EXTERNAL_ID = Number(
  process.env.REACT_APP_SG_SPECIALTY_EXTERNAL_ID,
);

const _3T_WORKPLACE_EXTERNAL_ID_ARRAY =
  process.env.REACT_APP_3T_WORKPLACE_EXTERNAL_ID_ARRAY.split(',');

/**
 * Checks if serviceTypeExternalId belongs to PHYSICAL consultation service type.
 * @param {number|string} serviceTypeExternalId
 * @returns {boolean}
 */
function isPhysicalConsultation(serviceTypeExternalId) {
  const id = Number(serviceTypeExternalId);

  const physicalConsultationIds = [
    SGK_SERVICE_TYPE_EXT_ID,
    GSK_SERVICE_TYPE_EXT_ID,
    SGKN_SERVICE_TYPE_EXT_ID,
    VGSK_SERVICE_TYPE_EXT_ID,
    EXPRESS_CARE_SERVICE_TYPE_EXT_ID,
  ];

  return physicalConsultationIds.includes(id);
}

/**
 * Checks if serviceTypeExternalId belongs to REMOTE consultation service type.
 * @param {number|string} serviceTypeExternalId
 * @returns {bool}
 */
function isRemoteConsultation(serviceTypeExternalId) {
  const id = Number(serviceTypeExternalId);

  const physicalConsultationIds = [
    NGK_SERVICE_TYPE_EXT_ID,
    NVGK_SERVICE_TYPE_EXT_ID,
  ];

  return physicalConsultationIds.includes(id);
}

/**
 * Checks if serviceTypeExternalId belongs to consultation service type.
 * @param {number|string} serviceTypeExternalId
 * @returns {bool}
 */
function isConsultationByServiceTypeExtId(serviceTypeExternalId) {
  return (
    isRemoteConsultation(serviceTypeExternalId) ||
    isPhysicalConsultation(serviceTypeExternalId)
  );
}

/**
 * Checks if categoryId belongs to consultation category.
 * @param {number|string} categoryId
 * @returns {bool}
 */
function isConsultationByCategoryId(categoryId) {
  const id = Number(categoryId);
  return id === CONSULTATIONS_CATEGORY_ID;
}

/**
 * Checks if serviceTypeExternalId belongs to service type that requires referral every time (even when paid)
 * @param {number|string} serviceTypeExternalId
 * @returns {bool}
 */
function isReferralAllwaysRequired(serviceTypeExternalId) {
  const id = Number(serviceTypeExternalId);
  const serviceTypesExternalids = [
    KT_SERVICE_TYPE_EXT_ID,
    M3DT_SERVICE_TYPE_EXT_ID,
    XRAY_SERVICE_TYPE_EXT_ID,
  ];

  return serviceTypesExternalids.includes(id);
}

/**
 * Checks if serviceTypeExternalId belongs to service type that doesnt show consultation reason
 * @param {number|string} serviceTypeExternalId
 * @param {bool} isPaid
 * @returns {bool}
 */
function isConsultationReasonNotShown(serviceTypeExternalId, isPaid) {
  const id = Number(serviceTypeExternalId);
  const serviceTypesExternalidsAlwaysNotShown = [
    KT_SERVICE_TYPE_EXT_ID,
    M3DT_SERVICE_TYPE_EXT_ID,
    XRAY_SERVICE_TYPE_EXT_ID,
  ];

  const serviceTypesExternalidsPSDFNotShown = [ULTRASOUND_SERVICE_TYPE_EXT_ID];

  const notShow =
    serviceTypesExternalidsAlwaysNotShown.includes(id) ||
    (!isPaid && serviceTypesExternalidsPSDFNotShown.includes(id));

  return notShow;
}

/**
 * Checks if serviceTypeExternalId belongs to service type shows refferal input fields (files or ehealth checks) every time (even when paid)
 * @param {number|string} serviceTypeExternalId
 * @returns {bool}
 */
function isReferralInputsAlwaysShown(serviceTypeExternalId) {
  const id = Number(serviceTypeExternalId);
  const serviceTypesExternalids = [
    ABUS_SERVICE_TYPE_EXT_ID,
    KT_SERVICE_TYPE_EXT_ID,
    M3DT_SERVICE_TYPE_EXT_ID,
    XRAY_SERVICE_TYPE_EXT_ID,
  ];

  return serviceTypesExternalids.includes(id);
}

/**
 * Checks if serviceTypeExternalId belongs to MRT service type
 * @param {number|string} serviceTypeExternalId
 * @returns {bool}
 */
function isMrt(serviceTypeExternalId) {
  const id = Number(serviceTypeExternalId);
  const serviceTypesExternalids = [MRT_SERVICE_TYPE_EXT_ID];

  return serviceTypesExternalids.includes(id);
}

/**
 * Checks if specialtyExternalId belongs to SG.
 * @param {number|string} specialtyExternalId
 * @returns {bool}
 */
function isSGBySpecialty(specialtyExternalId) {
  const id = Number(specialtyExternalId);
  const specialtyExternalIds = [SG_SPECIALTY_EXTERNAL_ID];
  return specialtyExternalIds.includes(id);
}

/**
 * Checks if specialtyExternalId belongs to SG.
 * @param {number|string} specialtyExternalId
 * @returns {bool}
 */
function is3TWorkplace(workplaceExternalId) {
  if (!workplaceExternalId) return false;
  return _3T_WORKPLACE_EXTERNAL_ID_ARRAY.includes(
    workplaceExternalId.toString(),
  );
}

export {
  isConsultationByServiceTypeExtId,
  isConsultationByCategoryId,
  isPhysicalConsultation,
  isRemoteConsultation,
  isReferralAllwaysRequired,
  isReferralInputsAlwaysShown,
  isConsultationReasonNotShown,
  isMrt,
  isSGBySpecialty,
  is3TWorkplace,
};
